<template>
  <div class="more-events-section">
    <p class="cs-textstyle-section-heading more-events-section__title">
      More Events
    </p>
    <div class="more-events-section__event-list">
      <cs-event-card
        v-for="event in events"
        :key="event.id"
        :tags="makeTag(event)"
        :title="event.title"
        :picture="event.picture"
        :datetime="event.date_time"
        :location="event.city.name || 'Online'"
        :organiser="event.group.name"
        picture-position="top"
        layout="small"
        hide-buttons
        @click="onOpenEventDetails(event)"
      ></cs-event-card>
    </div>
  </div>
</template>

<script>
import listEvents from '@/newgql/ListUpcomingEvents.gql';
import EventsCard from '@/components/events/EventsCard';

export default {
  components: {
    EventsCard
  },
  data() {
    return {
      id: this.$route.params.id
    };
  },
  apollo: {
    event: {
      query: listEvents,
      loadingKey: 'loading',
      watchQuery: { fetchPolicy: 'network-only' },
      fetchPolicy: 'network-only',
      variables() {
        return {
          today: this.$moment()
        };
      }
    }
  },
  computed: {
    events() {
      let outer_this = this;
      if (this.event) {
        return this.event.filter(function(obj) {
          return obj.id !== outer_this.id;
        });
      } else return [];
    }
  },
  methods: {
    onOpenEventDetails(event) {
      this.$router.push({ name: 'EventDetail', params: { id: event.id } });
    },
    makeTag(event) {
      let tags = [];
      let tag = event.group.type + ' event';
      tags.push(tag);
      return tags;
    }
  }
};
</script>

<style lang="scss" scoped>
.more-events-section {
  background-color: white;
  padding: 0px 20px 20px;
}
.more-events-section__event-list {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 20px;
  width: calc(100% + 20px);
}
.more-events-section__title {
  color: var(--cs-gray-06);
}
.more-events-section__event-list > * {
  flex: 0 0 auto;
  width: 300px;
}
.more-events-section__event-list .cs-card {
  margin: 0px;
  cursor: pointer;
  margin-bottom: 10px;
}
.cs-card:last-of-type {
  margin-right: 20px;
}
/deep/ .cs-card__info .cs-event-card__title {
  margin-top: 0;
}
</style>
